import { Delete } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {
  Box,
  Dialog,
  DialogActions,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import CustomButton from "../Common/CustomButton";

export default function EditInvoiceBulkModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const fileUploader = useRef<HTMLInputElement>(null);
  const selectedFile = useRef<File>(null);
  const [downloadingTemplate, setDownloadingTemplate] = useState(false);
  const [uploadingBulkTasks, setUploadingBulkTasks] = useState(false);
  const [fileName, setFileName] = useState(null);

  const downloadAddBulkTaskTemplate = () => {
    setDownloadingTemplate(true);
    // useFetch(API_ENDPOINTS.DOWNLOAD_BULK_CREATE_TASKS_TEMPLATE.url, "GET", {
    //   failureMessage: API_ENDPOINTS.DOWNLOAD_BULK_CREATE_TASKS_TEMPLATE.failureMessage,
    //   showSuccessToast: true,
    //   config: {
    //     params: {
    //       companyId: companyId,
    //       branchCode: branchCode,
    //     },
    //   },
    //   thenCallBack: (response) => {
    //     setDownloadingTemplate(false);
    //     const excelData = Buffer.from(response.data?.file, "base64");
    //     const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    //     const blob = new Blob([excelData], { type: fileType });
    //     saveAs(blob, "add-bulk-task-template.xlsx");
    //   },
    //   catchCallBack: () => {
    //     setDownloadingTemplate(false);
    //   },
    // });
  };

  const uploadBulkTasks = () => {
    const bodyFormData = new FormData();
    bodyFormData.append("file", selectedFile.current);

    setUploadingBulkTasks(true);
    // useFetch<{ updatedFilesList: string[] }>(API_ENDPOINTS.CREATE_TASKS_IN_BULK.url, "POST", {
    //   failureMessage: API_ENDPOINTS.CREATE_TASKS_IN_BULK.failureMessage,
    //   showSuccessToast: true,
    //   data: bodyFormData,
    //   thenCallBack: (res) => {
    //     setUploadingBulkTasks(false);
    //     selectedFile.current = null;
    //     setFileName(null);
    //     fetchTickets();
    //     if (res.data?.file) {
    //       setErrorWorkbook(res.data?.file);
    //       setTasksReport({
    //         totalTasks: res.data?.totalTasks,
    //         failedTasks: res.data?.remaningTasks,
    //         createdTasks: res.data?.taskCreated,
    //       });
    //       setShowBulkTasksUploadIssueModal(true);
    //     } else {
    //       setOpen(false);
    //       setShowBulkTasksModal(false);
    //     }
    //   },
    //   catchCallBack: () => {
    //     setUploadingBulkTasks(false);
    //   },
    // });
  };
  return (
    <>
      <Dialog open={open} sx={{ "& .MuiDialog-paper": { borderRadius: "4px", minWidth: "600px" } }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 2 }}>
          <Typography variant="h6">Edit Invoices in bulk</Typography>
          <IconButton
            onClick={() => {
              onClose();
              selectedFile.current = null;
              setFileName(null);
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />
        <List sx={{ padding: "16px" }}>
          <ListItem disablePadding>
            <ListItemButton
              disabled={downloadingTemplate || uploadingBulkTasks}
              onClick={() => {
                downloadAddBulkTaskTemplate();
              }}
            >
              <ListItemIcon>
                <DownloadIcon />
              </ListItemIcon>
              <ListItemText primary="Download Template" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <input
              ref={fileUploader}
              name="ConfirmDocUploader"
              type="file"
              multiple={false}
              onClick={(_e) => ((_e.target as HTMLInputElement).value = null)}
              onChange={(e) => {
                selectedFile.current = e.target.files[0];
                setFileName(selectedFile.current.name);
              }}
              hidden
              accept=".xlsx,.xls"
            />
            <ListItemButton
              disabled={downloadingTemplate || uploadingBulkTasks}
              onClick={() => {
                fileUploader.current && fileUploader.current.click();
              }}
            >
              <ListItemIcon>
                <FileUploadIcon />
              </ListItemIcon>
              <ListItemText primary="Upload Template" secondary={fileName ? `File Uploaded:${fileName}` : ""} />
            </ListItemButton>
            <ListItemButton
              sx={{ flexGrow: 0, width: "60px" }}
              disabled={uploadingBulkTasks || downloadingTemplate || (selectedFile.current ? false : true)}
              onClick={() => {
                selectedFile.current = null;
                setFileName(null);
              }}
            >
              <ListItemIcon>
                <Delete color={selectedFile.current ? "error" : "disabled"} />
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <DialogActions sx={{ padding: 2, background: "#F1F1F1" }}>
          <CustomButton
            disabled={uploadingBulkTasks || (selectedFile.current ? false : true)}
            variant="contained"
            onClick={() => {
              uploadBulkTasks();
            }}
          >
            <LoadingIcon loading={uploadingBulkTasks} />
            Confirm
          </CustomButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
